import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-status_error_warning",
  "use": "icon-status_error_warning-usage",
  "viewBox": "0 0 25.465 25.465",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25.465 25.465\" id=\"icon-status_error_warning\">\n  <path id=\"icon-status_error_warning_np_warning_2849764_000000\" d=\"M17.519,4.8A12.733,12.733,0,1,0,30.266,17.519,12.7,12.7,0,0,0,17.519,4.8Zm0,20.26a1.238,1.238,0,1,1,1.238-1.238A1.213,1.213,0,0,1,17.519,25.06Zm1.266-5.15a1.238,1.238,0,1,1-2.475,0V11.188a1.238,1.238,0,1,1,2.475,0Z\" transform=\"translate(-4.801 -4.801)\" fill=\"#c83532\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/status_error_warning.svg
// module id = 176
// module chunks = 0 1 2